import React from 'react';
import {Platform} from 'react-native';
import {BUTTON_TYPES} from '../../../utils/Constants';
import {tID} from '../../../utils/TestIdHelper';
import {getBiometricLabel} from '../../../utils/HelperMethods';
import BottomExpandableDrawer from '../BottomExpandableDrawer';

const FaceIdDisableDrawer = ({
  visible,
  onClose,
  onPressCancel,
  onPressMySetttings,
}) => {
  const subtitle =
    Platform.OS === 'ios'
      ? 'Please turn Face ID on in your device settings to enable it.'
      : 'Please set up fingerprint or face unlock in your device settings to enable it.';

  return (
    <BottomExpandableDrawer
      testID={tID('FaceIdDisableDrawer-Modal-BottomExpandableDrawer')}
      visible={visible}
      title={`${getBiometricLabel()} Disabled`}
      subtitle={subtitle}
      onClose={onClose}
      buttons={[
        {
          title: 'Cancel',
          buttonType: BUTTON_TYPES.Bordered,
          onPress: onPressCancel,
        },
        {
          title: 'My Settings',
          buttonType: BUTTON_TYPES.Filled,
          onPress: onPressMySetttings,
        },
      ]}
    />
  );
};

export default FaceIdDisableDrawer;
